var map = {
	"./b0.svg": "Db5y",
	"./b1.svg": "ZXyH",
	"./b10.svg": "3rEl",
	"./b11.svg": "xE8g",
	"./b12.svg": "Z9zZ",
	"./b2.svg": "hgIB",
	"./b3.svg": "/FA1",
	"./b4.svg": "kR76",
	"./b5.svg": "nYpP",
	"./b6.svg": "A6QG",
	"./b7.svg": "3EFp",
	"./b8.svg": "AXYe",
	"./b9.svg": "8if7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SyNt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip ^\.\/b.*\.svg$
// module id = SyNt
// module chunks = 0